import { t, Trans } from "@lingui/macro";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { Button, Container } from "@mui/material";
import moment from "moment";
import React from "react";
import { useToggle } from "react-use";

import { useSnackbar } from "@/components/shared/hooks";
import { notNullable } from "@/lib/util";
import { useClientCreateMutation } from "@/saleor/api";

import GenericDialog from "../shared/dialog/GenericDialog";
import ContactForm, { Contact } from "./ContactForm";

export interface CreateContactButtonProps {
	onCompleted?: () => void;
}

const CreateContactButton = ({ onCompleted }: CreateContactButtonProps) => {
	const [clientCreate] = useClientCreateMutation();
	const { showSnackbar } = useSnackbar();

	const [dialogOpen, toggleDialog] = useToggle(false);

	const handleCompleted = () => {
		toggleDialog();
		onCompleted && onCompleted();
		showSnackbar({
			message: t`New contact has been created successfully!`,
			severity: "success",
		});
	};

	const performMutation = async (values: Contact) => {
		const { data } = await clientCreate({
			variables: {
				client: {
					firstName: values.firstName,
					lastName: values.lastName,
					email: values.email,
					dateOfBirth: values.dateOfBirth
						? moment(values.dateOfBirth).format("YYYY-MM-DD")
						: null,
					defaultShippingAddress: {
						...values.address,
						firstName: values.firstName,
						lastName: values.lastName,
					},
				},
			},
		});
		// const apiErrors = result.errors || [];
		// const submitErrors = result.data?.clientCreate?.errors || [];
		return data?.clientCreate?.errors.filter(notNullable) || [];
	};

	return (
		<>
			<Button
				variant="contained"
				color="primary"
				className="capitalize"
				startIcon={<AddCircleOutlineIcon />}
				onClick={toggleDialog}
			>
				<Trans>Create Contact</Trans>
			</Button>
			<GenericDialog
				isOpen={dialogOpen}
				onClose={toggleDialog}
				fullWidth
				title={t`Create new Contact`}
			>
				<Container maxWidth="lg" className="pb-3">
					<ContactForm
						onCompleted={handleCompleted}
						onCancel={toggleDialog}
						updateMutation={performMutation}
					/>
				</Container>
			</GenericDialog>
		</>
	);
};

export default CreateContactButton;
